const React = require('react');

const UrlHelpers = require('components/shared/url_helpers.js');

const EMPTY_STATE_IMAGE = require('../../../images/icons/empty-states/no-listings@2x.png');

const shippingRegionLinkOpen = `<a href="${UrlHelpers.changeShippingRegionPath}"` +
  'data-remote-lightbox="true">';

const NoListingsTab = () =>
  <div className="align-center mtb-2">
    <img
      src={EMPTY_STATE_IMAGE}
      className="empty-state-icon-small mb-1"
      alt={I18n.t('comparisonShoppingPage.listingTab.emptyStateImgAlt')}
    />
    <h3 className="heading-3 normal mb-1">
      {I18n.t('comparisonShoppingPage.listingTab.noListings')}
    </h3>
    <p
      className="lead mb-1"
      dangerouslySetInnerHTML={{
        __html: I18n.t('comparisonShoppingPage.listingTab.tryChangingRegion', {
          linkOpen: shippingRegionLinkOpen,
          linkClose: '</a>',
        }),
      }}
    />
    <p className="mb-0">{I18n.t('comparisonShoppingPage.listingTab.youCanChangeHint')}</p>
  </div>;

module.exports = NoListingsTab;



// WEBPACK FOOTER //
// ./javascripts/components/comparison_shopping_page/no_listings_tab.jsx